export default store => ({
  getComponent(nextState, cb) {
    import("./containers/AnalyticsContainer").then(component => {
      cb(null, component.default);
    });
  }
});
